import { render, staticRenderFns } from "./ClientHistory.vue?vue&type=template&id=7ae560cc"
import script from "./ClientHistory.vue?vue&type=script&lang=js"
export * from "./ClientHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports